import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { GetStoreItemsQueryVariables } from '@/gql/graphql';

export const getStoreItems = async ({ storeServiceIds, menuOptions }: GetStoreItemsQueryVariables) => {
  const response = await queryExecute({
    variables: {
      storeServiceIds,
      menuOptions,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query GetStoreItems($storeServiceIds: StoreServiceIdsInput!, $menuOptions: StoreMenuOptionInput) {
        getStoreItems(storeServiceIds: $storeServiceIds, menuOptions: $menuOptions) {
          address
          storeItemsSections {
            title
            subtitle
            itemGroups {
              title
              subtitle
              price
              availableServices
              score
              price
              items {
                id
                storeId
                storeTitle
                title
                imageUrl
                subtitle
                service
                price
                displayPrice
                currency
                itemCursor
                quantity
                substitutionPreference
                serviceItemReference
                isSpecialInstructionsDisabled
              }
            }
          }
          menuOption
        }
      }
    `),
  });

  return response.data.getStoreItems;
};
